module.exports = __webpack_public_path__ + "media/images/leads_generation/organization-contacts-750b1091b3487ba13a4fd33dc0a58569.svg";